import ServerRequestWrapper from "../ServerRequestWrapper";
import { StatePersistor } from "../../utils/StatePersistor";
import * as Constants from "../../utils/Constants";
import AFrameReviewConstants from "../aframeboxlookup/Constants";
import EndpointsBase from "../EndpointsBase";
import { currentServerRoutePrefix } from "../../utils/UtilMethods";

const { LookupValueOrigin, LookupValueType } = AFrameReviewConstants;

const { API_PATH } = Constants;

const baseUri = API_PATH;
const server = new ServerRequestWrapper(baseUri + currentServerRoutePrefix);

class Endpoints extends EndpointsBase {
  getAFrameReviewBox(valueOrigin, lookupValue, checkStation) {
    let data = void 0;

    const method = ((valueOrigin, lookupValue) => {
      switch (valueOrigin) {
        case LookupValueOrigin.ScannedBarcode:
          data = {
            barcode: lookupValue,
            checkStation,
          };
          return `box/barcode/${lookupValue}`;
        case LookupValueOrigin.SortBoxNumber:
          data = {
            id: lookupValue,
            type: LookupValueType.SortBox,
            checkStation,
          };
          return `box/id`;
        case LookupValueOrigin.InvoiceNumber:
          data = {
            id: lookupValue,
            type: LookupValueType.Invoice,
            checkStation,
          };
          return `box/id`;
        case LookupValueOrigin.IpackBoxNumber:
          data = {
            id: lookupValue,
            type: LookupValueType.IpackBoxID,
            checkStation,
          };
          return `box/id`;
        default:
          return void 0;
      }
    })(valueOrigin, lookupValue, checkStation);

    return this._sendRequest({
      method: method,
      headers: this._getAuthHeader(),
      run: server.get,
      data: data,
    });
  }
  setAFrameControlledBy(operatorId, sortboxId, checkStation) {
    let data = {
      operatorId,
      sortboxId,
      checkStation,
    };
    return this._sendRequest({
      method: `box/controlled`,
      headers: this._getAuthHeader(),
      run: server.get,
      data,
    });
  }
}

export default new Endpoints();
